import { CollapsibleSection } from 'cpool-components/general/CollapsibleSection';

type Props = {
    children: React.ReactNode;
    title: string;
    icon?: React.ReactNode;
    headerChildren?: React.ReactNode;
    headerNotification?: React.ReactNode;
    testId?: string;
};

export const BankCreditRequestFormSection: React.FC<Props> = ({
    children,
    headerChildren,
    headerNotification,
    icon,
    testId,
    title,
}) => (
    <CollapsibleSection
        title={title}
        titleClassNames="text-sm text-midnight font-medium"
        headerChildren={headerChildren}
        headerNotification={headerNotification}
        bgClassNames="bg-white rounded-lg border-l-2 border-blue px-4 py-3"
        panelClassNames="pt-3"
        icon={icon}
        testId={testId}
    >
        {children}
    </CollapsibleSection>
);
